import { DeviceHub, ViewModule } from "@material-ui/icons";
import React from "react"
import { FaHome, FaCheck, FaRegSun, FaTicketAlt, FaCashRegister, FaMarker, FaMarkdown, FaAlipay, FaPersonBooth, FaTypo3, FaShoppingCart } from 'react-icons/fa'
const user = JSON.parse(sessionStorage.getItem('user'))

const navigationSuperAdmin = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "Centro de costo",
    title: "Centro de costo",
    type: "item",
    icon: <FaCashRegister size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/centro-costo"
  },
  {
    id: "Proveedores",
    title: "Proveedores",
    type: "item",
    icon: <FaPersonBooth size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/proveedores"
  },
  /* {
    id: "Tipo Equipo",
    title: "Tipo Equipo",
    type: "item",
    icon: <FaTypo3 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/tipo-equipo"
  }, */
  /* {
    id: "Conf Marca",
    title: "Conf Marca",
    type: "collapse",
    icon: <FaAlipay size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Gestionar Marcas",
        title: "Gestionar Marcas",
        type: "item",
        icon: <FaMarker size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/marcas"
      },
      {
        id: "Marca Modelo",
        title: "Marca Modelo",
        type: "item",
        icon: <ViewModule size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/marca-modelo"
      }
    ]
  }, */
  /* {
    id: "Hoja de vida",
    title: "Hoja de vida",
    type: "item",
    icon: <DeviceHub size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/hoja-vida"
  }, */
  /* {
    id: "historial-equipos",
    title: "Historial Estados",
    type: "item",
    icon: <FaTypo3 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/historial-estados"
  }, */
  {
    id: "Solicitudes de Compra",
    title: "Solicitudes de Compra",
    type: "collapse",
    icon: <FaShoppingCart size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "solicitudes-compra-listado",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/solicitudes-compra"
      },
      {
        id: "solicitudes-compra-categorias",
        title: "Categorías",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/solicitudes-compra/categorias"
      },
      {
        id: "solicitudes-compra-dashboard",
        title: "Indicadores",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/solicitudes-compra/dashboard"
      },
      {
        id: "solicitudes-compra-sla-config",
        title: "Configuración SLA",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/solicitudes-compra/sla-config"
      }
    ]
  },
  {
    id: "gsistema",
    title: "Sistema",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "sistema1",
        title: "Usuarios",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/users"
      },
      {
        id: "sistema2",
        title: "Áreas",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/area"
      },
      {
        id: "sistema3",
        title: "Cargos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/cargo"
      }
    ]
  },
  {
    id: "tickets",
    title: "Tickets",
    type: "collapse",
    icon: <FaTicketAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listado",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tickets",
      },
    ]
  },
];

const navigationUser = [
  {
    id: "tickets",
    title: "Tickets",
    type: "collapse",
    icon: <FaTicketAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listado",
        title: "Listado",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tickets",
      },
    ]
  },
  {
    id: "Solicitudes de Compra",
    title: "Solicitudes de Compra",
    type: "item",
    icon: <FaShoppingCart size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/solicitudes-compra"
  },
];

const navigationShopping = [
  {
    id: "tickets",
    title: "Tickets",
    type: "collapse",
    icon: <FaTicketAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listado",
        title: "IT",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tickets",
      },
      {
        id: "listado3",
        title: "Comunicaciones",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/ticketscomunicaciones",
      },
    ]
  },
  {
    id: "Solicitudes de Compra",
    title: "Solicitudes de Compra",
    type: "item",
    icon: <FaShoppingCart size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/solicitudes-compra"
  },
];

const navigationComunicaciones = [
  {
    id: "tickets",
    title: "Tickets",
    type: "collapse",
    icon: <FaTicketAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "listado",
        title: "IT",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tickets",
      },
      {
        id: "listado3",
        title: "Comunicaciones",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/tickets-comunicaciones",
      },
    ]
  }
];


const navigationSolicitudesCompra = [
  {
    id: "Solicitudes de Compra",
    title: "Solicitudes de Compra",
    type: "item",
    icon: <FaShoppingCart size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/solicitudes-compra"
  },
];

const navigationConfig =
  user?.profile === 2 ? navigationSuperAdmin :
    user?.profile === 3 ? navigationUser :
      user?.profile === 65 ? navigationShopping :
        user?.profile === 75 ? navigationComunicaciones :
          [76, 88, 89].includes(user?.profile) ? navigationSolicitudesCompra :
            []

export default navigationConfig
